module.exports = __webpack_public_path__ + "img/plan_osm.dad1795b.jpg";